import { forwardRef, useCallback } from "react";

const { styled } = require("@mui/material");

const HiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const VisuallyHiddenInput = forwardRef((props, ref) => {
  const internalOnChange = useCallback(
    (e) => {
      props.onChange && props.onChange?.(e);
    },
    [props.onChange],
  );

  return <HiddenInput ref={ref} {...props} onChange={internalOnChange} />;
});

export default VisuallyHiddenInput;
